<template lang="pug">
#resumo-analise(v-if='proposta?.etapas')
    .linha(:style='{ marginBottom : "30px"}')
        .coluna
            collapse-component(title='Resumo da análise', :isBasic='true')
                ResumoAnaliseTable(
                    :etapas='proposta.etapas',
                    @tb:toEtapa='toEtapa($event)'
                )

    .linha(:style='{ marginBottom : "30px"}')
        .coluna(v-if='proposta.aprovado !== "ANDAMENTO"')
            collapse-component(title='Resultado da análise', :isBasic='true')
                .aprovado(v-if='proposta.aprovado')
                    chip-component(
                        border-color='transparent',
                        :background-color='"var(--primary-light-green)"',
                        :color='"var(--primary-white)"',
                        :label='"Aprovado"',
                        border-radius='5px',
                        width='150px'
                    )

                .reprovado(v-else)
                    chip-component(
                        border-color='transparent',
                        :background-color='"var(--primary-light-red)"',
                        :color='"var(--primary-white)"',
                        :label='"Reprovado"',
                        border-radius='5px',
                        width='150px'
                    )

                    div.resumo-justificativa(
                        v-if='isAguardandoValidacao && proposta.justificativa'
                    )
                        i(style="line-height: 20px")  Justificativa geral:
                        div {{ proposta.justificativa }}

                    text-area-input-component(
                        v-else-if='isEmAnalise'
                        :style='{ paddingTop :  "30px"}',
                        v-model='proposta.justificativa',
                        label='Justificativa geral',
                        placeholder=''
                    )

                .card-resultado-analise(v-if='possuiMinuta || possuiPendencia')
                    .card-left(:style='{ background: possuiMinuta ? "var(--secondary-regular-green)" : "var(--secondary-regular-red)" }')
                        .card-icone(:style='{ background: possuiMinuta ? "var(--primary-green)" : "var(--secondary-red)" }')
                            .mdi.mdi-check
                    .body-card(:style='{ background: possuiMinuta ? "var(--secondary-light-green)" : "var(--secondary-light-red)" }')
                        .resultado-analise Análise {{ possuiMinuta ? 'aprovada' : 'reprovada' }}
                        .visualizar-minuta(
                            v-if='possuiMinuta'
                            @click='visualizarMinuta(proposta.pathTC)'
                        ) Clique aqui para visualizar a minuta

    .linha(v-if='isGerenteOperacional && isAguardandoValidacao', :style='{ marginBottom : "30px"}')
        .coluna
            collapse-component(title='Validação da análise', :isBasic='true')
                .validacao-analise
                    radio-button-component(
                        label='Aprovar o resultado da análise do técnico?'
                        v-model='validacaoGO.aprovado',
                        radioDirection='column'
                        :list='aprovadoOptions',
                    )
                text-area-input-component(
                    v-if='validacaoGO.aprovado === "REPROVADO"'
                    :style='{ paddingTop :  "30px"}',
                    v-model='validacaoGO.justificativa',
                    label='Justificativa geral',
                    placeholder=''
                )

</template>

<script>
import {
    buscarEtapaResumo,
    finalizarAvaliacaoTecnico,
    salvarValidacaoGO
} from '@/services/processo.service';
import ResumoAnaliseTable from '@/views/analise/components/etapaResumo/ResumoAnaliseTable.vue';
import { Perfil } from '@/utils/constants.utils.js';
import { CondicaoEnum } from '@/enums/processo.enum';

export default {

    name: 'EtapaRESUMO',

    components: {
        ResumoAnaliseTable
    },

    props: {
        processo: {
            type: Object, // Ajuste o tipo conforme necessário (String, Object, Number, etc.)
            required: true
        }
    },
    data() {
        return {
            idProcesso: this.$route.params.id,
            aprovadoGO: null,
            aprovadoOptions: [
                { id: 'APROVADO', label: 'Sim. Notificar proprietário/possuidor o resultado da análise.', checked: false },
                { id: 'REPROVADO', label: 'Não. Retornar ao técnico para revisão da análise.', checked: false },
            ],
            proposta: {},
            validacaoGO: {}
        };
    },

    computed: {
        isGerenteOperacional() {
            return this.$eu().perfil === Perfil.GERENTE_OPERACIONAL;
        },
        isAguardandoValidacao() {
            return this.$route.params.condicao === CondicaoEnum.AGUARDANDO_VALIDACAO_ANALISE.id;
        },
        possuiMinuta() {
            return this.$route.params.condicao === CondicaoEnum.AGUARDANDO_ASSINATURA.id;
        },
        possuiPendencia() {
            return this.$route.params.condicao === CondicaoEnum.AGUARDANDO_ATENDIMENTO_PENDENCIA.id;
        },
        isEmAnalise() {
            return this.$route.params.condicao === CondicaoEnum.EM_ANALISE.id;
        }
    },

    async mounted() {
        try {
            let responseEtapa = await buscarEtapaResumo(this.idProcesso);
            this.proposta = {
                etapas: [
                    {
                        nome: 'Etapa IARA',
                        etapa: 'etapaIARA',
                        status: this.getStatus(responseEtapa.resultadoEtapaIARA),
                        acao: ''
                    },
                    {
                        nome: 'Etapa MRA',
                        etapa: 'etapaMRA',
                        status: this.getStatus(responseEtapa.resultadoEtapaMRA),
                        acao: ''
                    },
                    {
                        nome: 'Etapa PRADA',
                        etapa: 'etapaPRADA',
                        status: this.getStatus(responseEtapa.resultadoEtapaPRADA),
                        acao: ''
                    },
                ],
                justificativa: responseEtapa?.justificativa ?? null,
                aprovado: this.getStatus(responseEtapa.resultadoProcesso),
                pathTC: ''
            }
            if ( this.roundToTwo(this.processo.areaTotalCompensar) === 0 && this.roundToTwo(this.processo.areaTotalRecompor) === 0 && this.processo.existeFormularioPrada) {

                const etapaMRA = this.proposta.etapas.find(etapa => etapa.etapa === 'etapaMRA');
                if (etapaMRA) {
                    etapaMRA.status = 'DISPENSADO';
                }

                const etapaPRADA = this.proposta.etapas.find(etapa => etapa.etapa === 'etapaPRADA');
                if (etapaPRADA) {
                    etapaPRADA.status = 'DISPENSADO';
                }
            }
        } catch {
        }

        this.$emit('resultado', this.proposta.aprovado);
    },

    methods: {
        getStatus(resultado) {
            if (resultado === "ANDAMENTO") {
                return resultado;
            } else {
                return resultado === 'APROVADO';
            }
        },

        toEtapa(event) {
            this.$emit('toEtapa', event?.etapa)
        },

        visualizarMinuta(path) {
            alert('download')
        },

        async finalizarAvaliacaoTecnica() {
            try {
                const processo = await finalizarAvaliacaoTecnico({
                    idProcesso: this.idProcesso,
                    justificativa: this.proposta.justificativa
                })
                this.$toast({
                    showClose: true,
                    message: 'Avaliação técnica concluída com sucesso!',
                    type: 'success'
                });
                this.$router.push({ name: 'analise-proposta' });
            } catch (e) {
            }
        },

        async validarGO() {
            try {
                const processo = await salvarValidacaoGO({
                    idProcesso: this.idProcesso,
                    justificativa: this.validacaoGO.aprovado === 'REPROVADO' ? this.validacaoGO.justificativa : null,
                    aprovado: this.validacaoGO.aprovado === 'APROVADO' ? true : false
                })
                this.$toast({
                    showClose: true,
                    message: 'Avaliação do gerente concluída com sucesso!',
                    type: 'success'
                });
                this.$router.push({ name: 'validacao-proposta' });
            } catch (e) {
                this.$toast({
                    showClose: true,
                    message: 'Ocorreu um erro ao tentar salvar a validação da análise.',
                    type: 'error'
                });
            }
        },

        roundToTwo(value) {
            return Math.round(value * 100) / 100;
        },
    },
}

</script>

<style lang="scss" scoped>
.aprovado {
    display: flex;
    justify-content: space-between;
}

.reprovado {}

.resumo-justificativa {
    margin-top: 20px;
}

.card-resultado-analise {
    margin: 20px 0px;
    height: 40px;
    display: flex;
}

.card-left {
    width: 50px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px 0px 0px 4px;
}

.card-icone {
    height: 21px;
    width: 21px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
}

.body-card {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    border-radius: 0px 4px 4px 0px;
}

.resultado-analise {
    font-weight: 600;
    color: #434343;
    margin: 0px 24px;
}

.visualizar-minuta {
    color: #0A6EE3;
    text-decoration: underline;
    cursor: pointer;
}
</style>
